import React from "react";
import styled, { keyframes } from "styled-components";
import { ChallengeButton } from "../../components/buttons/ChallengeButton";
import { SkipButton } from "../../components/buttons/SkipButton";
import { UndoButton } from "../../components/buttons/UndoButton";
import Header from "../../components/game/Header";
import tut0 from "../../resources/tutorial0.gif";
import tut1 from "../../resources/tutorial2.gif";
import { Redirect } from "react-router-dom";

import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink
} from "react-router-dom";
import Canvas from "../../components/game/Canvas";

const fadeInUp = keyframes`
from {
    opacity:0;
    transform: translateY(10%);
  }

  to {
    opacity:1;
    transform: translateY(0%);
  }
`;

const StyledBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #342c3a;
  color: white;
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
  width: 100%;
  height: 100%;
  -webkit-tap-highlight-color: transparent;
`;

const inputWord = (
  <svg
    width="218"
    height="74"
    viewBox="0 0 218 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d)">
      <rect width="218" height="66" rx="8" fill="#E6E2D6" />
      <rect x="0.5" y="0.5" width="217" height="65" rx="7.5" stroke="white" />
    </g>
    <path
      d="M100.477 25.728C100.621 25.92 100.709 26.144 100.741 26.4C100.741 26.496 100.733 26.592 100.717 26.688C100.717 26.768 100.709 26.848 100.693 26.928C100.677 27.104 100.573 27.272 100.381 27.432C100.269 27.512 100.125 27.592 99.9486 27.672C99.8526 27.704 99.7486 27.728 99.6366 27.744C99.5406 27.744 99.4286 27.752 99.3006 27.768C99.2046 27.8 99.1006 27.816 98.9886 27.816C98.8766 27.816 98.7646 27.816 98.6526 27.816H97.5726L92.5566 27.84V27.912L92.5326 31.824C92.6606 31.824 92.7966 31.824 92.9406 31.824C93.1006 31.824 93.2926 31.816 93.5166 31.8C94.1566 31.8 94.7246 31.8 95.2206 31.8C95.7326 31.8 96.2926 31.808 96.9006 31.824H97.0446C97.2206 31.824 97.3966 31.832 97.5726 31.848C97.7646 31.848 97.9566 31.848 98.1486 31.848C98.3246 31.864 98.5006 31.888 98.6766 31.92C98.8526 31.936 99.0286 31.976 99.2046 32.04C99.4926 32.136 99.7006 32.288 99.8286 32.496C100.005 32.704 100.093 32.92 100.093 33.144C100.093 33.24 100.093 33.336 100.093 33.432C100.093 33.512 100.077 33.6 100.045 33.696C100.029 33.824 99.9246 33.984 99.7326 34.176C99.6046 34.288 99.4526 34.36 99.2766 34.392C99.1966 34.424 99.1006 34.456 98.9886 34.488C98.8926 34.504 98.7886 34.52 98.6766 34.536C98.5646 34.552 98.4526 34.568 98.3406 34.584C98.2446 34.584 98.1326 34.584 98.0046 34.584H96.9006L92.4846 34.608L92.4126 40.176V40.368C92.4126 40.448 92.4046 40.528 92.3886 40.608C92.3886 40.672 92.3806 40.744 92.3646 40.824C92.3326 40.904 92.3006 40.992 92.2686 41.088C92.2526 41.168 92.2286 41.248 92.1966 41.328C92.0846 41.552 91.9806 41.704 91.8846 41.784C91.7086 41.912 91.4926 42 91.2366 42.048C90.8046 42.144 90.3966 42.096 90.0126 41.904C89.9326 41.856 89.8526 41.8 89.7726 41.736C89.7086 41.656 89.6526 41.56 89.6046 41.448C89.5726 41.384 89.5566 41.336 89.5566 41.304L89.4846 41.16C89.4366 41.08 89.4046 41 89.3886 40.92C89.3726 40.824 89.3566 40.736 89.3406 40.656C89.3406 40.576 89.3326 40.496 89.3166 40.416C89.3166 40.336 89.3086 40.256 89.2926 40.176C89.2766 40.048 89.2766 39.92 89.2926 39.792V39.408L89.3166 37.536L89.3406 34.08C89.3566 33.568 89.3646 33.048 89.3646 32.52C89.3646 31.992 89.3646 31.448 89.3646 30.888C89.3486 30.312 89.3406 29.8 89.3406 29.352C89.3566 28.904 89.3806 28.416 89.4126 27.888V27.768C89.4286 27.592 89.4366 27.432 89.4366 27.288C89.4366 27.128 89.4526 26.968 89.4846 26.808C89.5166 26.456 89.5966 26.144 89.7246 25.872C89.8366 25.6 89.9966 25.408 90.2046 25.296C90.4446 25.152 90.7006 25.08 90.9726 25.08C91.1006 25.08 91.2046 25.088 91.2846 25.104V25.08C91.5726 25.08 91.8046 25.08 91.9806 25.08C92.1566 25.08 92.3246 25.08 92.4846 25.08C92.6446 25.08 92.8206 25.08 93.0126 25.08C93.2046 25.064 93.4606 25.056 93.7806 25.056C95.0606 25.04 96.3246 25.04 97.5726 25.056H97.6926C97.8686 25.072 98.0446 25.08 98.2206 25.08C98.4126 25.08 98.6046 25.088 98.7966 25.104C98.9726 25.104 99.1486 25.128 99.3246 25.176C99.5006 25.208 99.6766 25.256 99.8526 25.32C100.125 25.4 100.333 25.536 100.477 25.728ZM105.347 32.904C105.347 33.352 105.347 33.856 105.347 34.416C105.363 34.976 105.371 35.56 105.371 36.168C105.371 36.76 105.371 37.352 105.371 37.944C105.371 38.52 105.363 39.056 105.347 39.552C105.331 39.792 105.307 40.056 105.275 40.344C105.243 40.616 105.179 40.872 105.083 41.112C104.987 41.352 104.835 41.552 104.627 41.712C104.435 41.856 104.171 41.92 103.835 41.904C103.339 41.872 102.979 41.656 102.755 41.256C102.547 40.856 102.427 40.296 102.395 39.576C102.395 39.208 102.387 38.784 102.371 38.304C102.371 37.824 102.363 37.336 102.347 36.84C102.347 36.344 102.347 35.864 102.347 35.4C102.347 34.92 102.347 34.488 102.347 34.104C102.347 33.88 102.339 33.608 102.323 33.288C102.323 32.968 102.331 32.64 102.347 32.304C102.363 31.968 102.403 31.648 102.467 31.344C102.531 31.024 102.635 30.76 102.779 30.552C102.891 30.424 103.051 30.328 103.259 30.264C103.467 30.184 103.683 30.144 103.907 30.144C104.147 30.144 104.371 30.184 104.579 30.264C104.803 30.344 104.963 30.456 105.059 30.6C105.123 30.696 105.171 30.832 105.203 31.008C105.235 31.184 105.259 31.384 105.275 31.608C105.307 31.816 105.323 32.04 105.323 32.28C105.339 32.504 105.347 32.712 105.347 32.904ZM104.435 28.056C103.939 28.184 103.523 28.136 103.187 27.912C102.867 27.672 102.667 27.32 102.587 26.856C102.523 26.52 102.547 26.224 102.659 25.968C102.771 25.712 102.939 25.52 103.163 25.392C103.387 25.248 103.643 25.184 103.931 25.2C104.219 25.216 104.507 25.328 104.795 25.536C105.067 25.728 105.259 25.952 105.371 26.208C105.499 26.464 105.539 26.712 105.491 26.952C105.459 27.192 105.355 27.416 105.179 27.624C105.003 27.816 104.755 27.96 104.435 28.056ZM113.192 37.776C112.888 37.584 112.544 37.432 112.16 37.32C111.792 37.208 111.408 37.104 111.008 37.008C110.624 36.912 110.248 36.808 109.88 36.696C109.512 36.568 109.176 36.392 108.872 36.168C108.216 35.672 107.832 35.064 107.72 34.344C107.624 33.608 107.784 32.872 108.2 32.136C108.424 31.752 108.72 31.44 109.088 31.2C109.456 30.944 109.856 30.752 110.288 30.624C110.736 30.48 111.192 30.4 111.656 30.384C112.12 30.368 112.56 30.392 112.976 30.456C113.248 30.504 113.536 30.576 113.84 30.672C114.144 30.752 114.424 30.864 114.68 31.008C114.952 31.152 115.192 31.336 115.4 31.56C115.624 31.768 115.784 32.032 115.88 32.352C115.944 32.56 115.952 32.76 115.904 32.952C115.872 33.144 115.792 33.304 115.664 33.432C115.552 33.56 115.4 33.656 115.208 33.72C115.032 33.784 114.84 33.8 114.632 33.768C114.392 33.72 114.168 33.648 113.96 33.552C113.752 33.456 113.544 33.352 113.336 33.24C113.128 33.128 112.912 33.032 112.688 32.952C112.48 32.872 112.256 32.832 112.016 32.832C111.648 32.816 111.344 32.88 111.104 33.024C110.864 33.168 110.696 33.344 110.6 33.552C110.52 33.76 110.528 33.984 110.624 34.224C110.736 34.464 110.96 34.672 111.296 34.848C111.6 35.008 111.936 35.136 112.304 35.232C112.672 35.328 113.032 35.424 113.384 35.52C113.752 35.616 114.104 35.728 114.44 35.856C114.792 35.984 115.104 36.16 115.376 36.384C115.904 36.816 116.224 37.32 116.336 37.896C116.464 38.472 116.432 39.04 116.24 39.6C116.048 40.16 115.712 40.656 115.232 41.088C114.768 41.52 114.216 41.808 113.576 41.952C113.112 42.048 112.608 42.096 112.064 42.096C111.536 42.096 111.008 42.04 110.48 41.928C109.968 41.816 109.472 41.64 108.992 41.4C108.528 41.16 108.136 40.856 107.816 40.488C107.592 40.232 107.472 39.944 107.456 39.624C107.456 39.288 107.52 39 107.648 38.76C107.792 38.504 107.992 38.328 108.248 38.232C108.504 38.136 108.792 38.192 109.112 38.4C109.368 38.576 109.672 38.752 110.024 38.928C110.376 39.088 110.728 39.216 111.08 39.312C111.432 39.408 111.768 39.456 112.088 39.456C112.424 39.456 112.712 39.384 112.952 39.24C113.304 39.016 113.488 38.76 113.504 38.472C113.52 38.168 113.416 37.936 113.192 37.776ZM127.715 37.272C127.731 37.592 127.739 37.928 127.739 38.28C127.739 38.616 127.731 38.928 127.715 39.216C127.699 39.648 127.675 40.048 127.643 40.416C127.611 40.768 127.547 41.072 127.451 41.328C127.355 41.568 127.203 41.752 126.995 41.88C126.803 41.992 126.531 42.024 126.179 41.976C125.811 41.928 125.547 41.752 125.387 41.448C125.227 41.144 125.115 40.8 125.051 40.416C125.003 40.016 124.987 39.616 125.003 39.216C125.019 38.816 125.019 38.504 125.003 38.28C124.987 37.928 124.971 37.528 124.955 37.08C124.955 36.616 124.907 36.184 124.811 35.784C124.731 35.368 124.587 35.016 124.379 34.728C124.171 34.44 123.859 34.288 123.443 34.272C122.915 34.24 122.507 34.28 122.219 34.392C121.947 34.504 121.747 34.672 121.619 34.896C121.491 35.104 121.411 35.36 121.379 35.664C121.363 35.968 121.331 36.296 121.283 36.648L121.259 37.584V39.336C121.259 39.624 121.251 39.928 121.235 40.248C121.235 40.552 121.187 40.832 121.091 41.088C120.995 41.344 120.843 41.56 120.635 41.736C120.443 41.912 120.155 42 119.771 42C119.291 42 118.931 41.848 118.691 41.544C118.467 41.224 118.355 40.832 118.355 40.368V26.568C118.355 26.472 118.355 26.384 118.355 26.304C118.371 26.208 118.387 26.112 118.403 26.016C118.435 25.92 118.459 25.832 118.475 25.752C118.491 25.656 118.515 25.568 118.547 25.488C118.595 25.328 118.675 25.208 118.787 25.128C118.867 25.048 118.947 24.984 119.027 24.936C119.107 24.888 119.195 24.856 119.291 24.84C119.371 24.824 119.459 24.816 119.555 24.816C119.651 24.8 119.747 24.792 119.843 24.792C120.083 24.792 120.315 24.864 120.539 25.008C120.635 25.072 120.723 25.144 120.803 25.224C120.883 25.288 120.947 25.384 120.995 25.512C121.123 25.816 121.187 26.104 121.187 26.376C121.203 26.456 121.211 26.576 121.211 26.736C121.227 26.88 121.235 27.032 121.235 27.192C121.235 27.352 121.235 27.512 121.235 27.672C121.251 27.816 121.259 27.928 121.259 28.008V28.128C121.275 28.64 121.283 29.16 121.283 29.688C121.283 30.216 121.283 30.752 121.283 31.296V31.704C121.955 31.48 122.659 31.376 123.395 31.392C124.131 31.392 124.787 31.536 125.363 31.824C125.955 32.128 126.403 32.472 126.707 32.856C127.027 33.24 127.259 33.664 127.403 34.128C127.547 34.592 127.627 35.088 127.643 35.616C127.675 36.144 127.699 36.696 127.715 37.272Z"
      fill="black"
    />
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="0"
        width="218"
        height="74"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="8" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

const StyledTutorialWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  left: 8px;
  right: 8px;
  top: 136px;
  bottom: 100px;
  pointer-events: auto;
  overflow: visible;
`;

const StyledTutorialCanvas = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background: #ffffff;
  border: 1px solid #ff6c64;
  box-sizing: border-box;
  box-shadow: 0px 8px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  height: 100%;
  margin-bottom: 8px;
  width: 220px;
  height: 220px;
  animation: ${fadeInUp} 1s cubic-bezier(0.19, 1, 0.22, 1) 1;
  animation-delay: 0.2s;
  animation-fill-mode: backwards;
`;

const StyledPlayerText = styled.span`
background:${props => (props.one ? "#0085CC" : "#CC6200")}
border-radius:8px;
padding: 8px 8px 8px 8px;
`;

const StyledTutorialContent = styled.div`
  align-self: center;

  animation: ${fadeInUp} 1s cubic-bezier(0.19, 1, 0.22, 1) 1;
  animation-delay: 0.2s;
  animation-fill-mode: backwards;
`;

const StyledTutorialImg = styled.img`
display: inline-block
  width: 100%;
  border-radius: 8px;
`;

const StyledTutorialText = styled.div`
  align-content: center;
  font-family: Jua;
  line-height: 2.2;
  font-size: 22px;
  margin-top: 16px;
  text-align: center;
  animation: ${props => (props.play ? fadeInUp : "none")} 1s
    cubic-bezier(0.19, 1, 0.22, 1) 1;
  animation-delay: 0.2s;
  animation-fill-mode: backwards;
`;

const StyledButtonsWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  min-height: 100px;
  pointer-events: none;
  visibility: show;

  a {
    text-decoration: none;
  }
`;

export default class TutorialScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tutorialpage: 0
    };

    this.img1 = new Image();
    this.img2 = new Image();
  }

  componentDidMount() {
    this.img1.src = { tut0 };
    this.img2.src = { tut1 };
  }

  handlePlayClick = () => {
    const currentPage = this.state.tutorialpage;
    console.log(`Current tutorial page is ${currentPage}`);

    if (currentPage == 3) {
      this.props.onGameStart();
    } else {
      this.setState({
        tutorialpage: currentPage + 1
      });
    }
  };

  render() {
    let imgToShow;
    let textToShow;
    let wrapper;

    if (this.state.tutorialpage == 0) {
      imgToShow = tut0;
      textToShow = (
        <React.Fragment>
          <StyledPlayerText one>Player 1</StyledPlayerText> {""}
          <span>
            draws three <br /> random lines.
          </span>
        </React.Fragment>
      );
      wrapper = (
        <StyledTutorialCanvas>
          <StyledTutorialImg rel="preload" src={imgToShow} />
        </StyledTutorialCanvas>
      );
    } else if (this.state.tutorialpage == 1) {
      textToShow = (
        <React.Fragment>
          <StyledPlayerText one>Player 1</StyledPlayerText> {""}
          <span>
             enters an object
            <br />
            for 
          </span> {""}
          <StyledPlayerText>Player 2</StyledPlayerText> <span> to draw.</span>
        </React.Fragment>
      );
      wrapper = <StyledTutorialContent>{inputWord}</StyledTutorialContent>;
    } else if (this.state.tutorialpage == 2) {
      textToShow = (
        <React.Fragment>
          <StyledPlayerText one>Player 1</StyledPlayerText> {""}
          <span>
            passes the device <br /> to
          </span> {""}
          <StyledPlayerText>Player 2</StyledPlayerText>
        </React.Fragment>
      );
    } else {
      imgToShow = tut1;
      textToShow = (
        <React.Fragment>
          <StyledPlayerText>Player 2</StyledPlayerText> {""}
          <span>
            has 30 seconds
            <br />
            to complete the sketch.
          </span>
        </React.Fragment>
      );
      wrapper = (
        <StyledTutorialCanvas>
          <StyledTutorialImg rel="preload" src={imgToShow} />
        </StyledTutorialCanvas>
      );
    }

    return (
      <StyledBackground>
        <Header player={0} />
        <StyledTutorialWrapper>
          {wrapper}
          <StyledTutorialText play>
            {" "}
            <span> {textToShow} </span>
          </StyledTutorialText>
        </StyledTutorialWrapper>

        <StyledButtonsWrapper>
          <SkipButton
            text={this.state.tutorialpage == 3 ? "Play!" : "Next"}
            onClick={this.handlePlayClick}
          />
        </StyledButtonsWrapper>
      </StyledBackground>
    );
  }
}
